import { all } from "redux-saga/effects";
import * as AuthSaga from "./authSaga";
import * as JobsSaga from "./jobsSaga";
import * as VacancySaga from "./vacancySaga";
import * as StageSaga from "./stageSaga";
import * as StagePositionSaga from "./stagePositionSaga";
import * as FormInputsSaga from "./formInputsSaga";
import * as QuestionSaga from "./questionSaga";
import * as RailsSaga from "./railsSaga";
import * as AssociationSaga from "./vacancyAssociationSaga";
import * as CandidatesSaga from "./candidatesSaga";
import * as MessagesSaga from "./messageSaga";
import * as ManagerSaga from "./managerSaga";
import * as DocumentsSaga from "./DocumentsSaga";
import * as EmployeeSaga from "./employeeSaga";
import * as ContractSaga from "./contractsSaga";
import * as DoubtsSaga from "./DoubtsSaga"

import * as BankOfTalentsSaga from "./bankOfTalentsSaga"

function* Sagas() {
  yield all([
    AuthSaga.watcherSaga(),
    JobsSaga.watcherSaga(),
    VacancySaga.watcherSaga(),
    StageSaga.watcherSaga(),
    StagePositionSaga.watcherSaga(),
    FormInputsSaga.watcherSaga(),
    QuestionSaga.watcherSaga(),
    RailsSaga.watcherSaga(),
    AssociationSaga.watcherSaga(),
    CandidatesSaga.watcherSaga(),
    MessagesSaga.watcherSaga(),
    ManagerSaga.watcherSaga(),
    DocumentsSaga.watcherSaga(),
    EmployeeSaga.watcherSaga(),
    ContractSaga.watcherSaga(),
    BankOfTalentsSaga.watcherSaga(),
    DoubtsSaga.watcherSaga(),
  ]);
}

export default Sagas;
